// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__HiR6k","buttons":"RemoveExpirationActionButtons_buttons__1J8XV"};